import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFlagCheckered} from "@fortawesome/free-solid-svg-icons";

export default function TimelineFinish (){
    return(<div style={{ color: "#7a7a7a"}} className="text-center"><p>Finished</p><FontAwesomeIcon style={{fontSize: "50px"}} icon={faFlagCheckered} /></div>)
}